import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../services/apiClient';
import { GetTimeSlipSettings } from "../../config/config";
export const GetTimeSlipSetting = createAsyncThunk(
  'timeslip/GetTimeSlipSetting',
  async (_arg: any, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(GetTimeSlipSettings, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'mode': 'outlook'

        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const timeSlipSettingsSlice = createSlice({
  name: 'timeSlipSettings',
  initialState: {
    settings: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetTimeSlipSetting.pending, (state) => {
        state.loading = true;
        state.settings = null;
        state.error = null;
      })
      .addCase(GetTimeSlipSetting.fulfilled, (state, action) => {
        state.loading = false;

        state.settings = action.payload;
      })
      .addCase(GetTimeSlipSetting.rejected, (state, action) => {
        state.loading = false;

        state.error = null;
      });
  },
});

export default timeSlipSettingsSlice.reducer;
